import XHR from '../xhr/XHR';
import ErrorHelper from './ErrorHelper';
import { SimpleUri } from '../uri/SimpleUri';

export interface IDataCompletenessContext {
    telemetryTenantToken: string;
    appVersion: string;
    environment?: string;
    workload?: string;
    farmLabel?: string;
    callbackEndpoint: SimpleUri;
}

export class DataCompletenessInfo {
    private _dataCompletenessJson: string;
    private _endpointUrl: string;

    constructor(context: IDataCompletenessContext, isSuccess: number, statusCode: number, timestamp: number, events: any[]) {
        this._endpointUrl = context.callbackEndpoint.authority + context.callbackEndpoint.path;

        var eventSummary = {};
        if (events) {
            for (var e = 0; e < events.length; ++e) {
                eventSummary[events[e].EventType] = eventSummary[events[e].EventType] + 1 || 1;
            }
        }

        var completenessDataObj = {
            'TelemetryTenantId': context.telemetryTenantToken.substring(0, 32), // First 32 characters of the aria token is the aria tenant id
            'AppVersion': context.appVersion,
            'EventType': isSuccess,
            'StatusCode': statusCode,
            'EventCount': events ? events.length : 0,
            'Timestamp': timestamp,
            'Environment': context.environment ||  "",
            'DatapointSchemaVersion': '1.0',
            'TelemetrySource': 'Aria',
            'EventSummary' : eventSummary,
            'Workload': context.workload || "",
            'FarmLabel': context.farmLabel || ""
        };

        this._dataCompletenessJson = JSON.stringify(completenessDataObj);
    }

    public get endpointUrl(): string {
        return this._endpointUrl;
    }

    public get dataCompletenessJson(): string {
        return this._dataCompletenessJson;
    }

    public send() {
        var xhr = new XHR({
            method: 'POST',
            url: this._endpointUrl,
            json: this._dataCompletenessJson,
            requestTimeoutInMS: 1000
        });

        xhr.start(
            (xhr: XMLHttpRequest, status: number) => {
                // success, no op
            },
            (xhr: XMLHttpRequest, statusCode: number, timeout: boolean) => {
                if (typeof DEBUG !== 'undefined' && DEBUG) {
                    // Display errors if the completeness info couldn't be sent
                    ErrorHelper.log(new Error(`DataCompletenessInfo failed to be sent with status code ${statusCode}`));
                }
            }
        );
    }
}